export const namespaceCode = {
    15 : "Common", // not use
    16 : "tags", 
    17 : "Storage", // not use
    20 : "Wallet", // not use
    21 : "inventory", 
    25 : "data-management", 
    30 : "CRM", // not use
    31 : "privileges", 
    32 : "Topup", // not use
    33 : "flashdeal",
    35 : "fulfillment", 
    50 : "banner", 
    51 : "article", 
    55 : "document", 
    60 : "survey", 
    //61 : "survey-quiz", 
    70 : "Payment", // not use
    80 : "pdpa", 
    81 : "lucky-winner",
    82 : "lucky-draw",
    90 : "report", 
    92 : "ais-point", 
}